define('views/profile/profile_content',[
    'backbone',
    'views/_base/baseview',
    'text!views/profile/profile_content.html',
    'models/user/profile/profile'
], function(Backbone, BaseView, Template, ProfileModel){
    'use strict';

    return BaseView.extend({
        className: 'profile-content',
        tagName : 'div',
        isRender: true,
        needsAuth: false,
        template: _.template(Template),
        events  : {
            'click .js-profile-settings-options-img-edit': 'promptPhotoSelection',
            'click .js-profile-settings-options-pw-change': 'changePassword'
        },
        initialize: function(options){
            options = options || {};

            this.url_img_path = pf.consumerURL + '/Profile/Upload';

            this.wellness = pf.getFeature(enums.features.wellness);
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.$('#image-upload-input').change(function(e){ that.editPhoto(e); });

            return this;
        },

        loadData: function(){
            var that = this;

            if(this.wellness){

                if(!pf.wellness_account){

                    pf.controller.loadWellnessAccount(function(){

                        that.addAccountInformation();

                    });

                } else {
                    this.addAccountInformation();
                }

            } else {

                pf.controller.loadAccounts(function(){
                    that.addAccountInformation();
                });

            }

        },

        addAccountInformation: function(){

            if(this.wellness){

                var account = pf.wellness_account,
                    account_card_number = account.card_number;

            } else {

                var account = pf.accounts.spending_account,
                    account_card_number = (account.account_name.indexOf('Account')) ? account.account_name.slice(account.account_name.indexOf('Account')+8) : account.account_name;

            }

            var session_img = pf.session.get('PhotoURL'),
                profile_img = (session_img && session_img != '') ? session_img : 'img/profile/user.png';
            
            this.$('.js-profile-settings-acc-num').html(account.proxy_number);

            this.$('.js-profile-settings-card-num').html(account_card_number);

            this.$('.js-profile-img').css({ background: 'url("'+ profile_img +'") no-repeat' });

        },

        promptPhotoSelection: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            this.$('#image-upload-input').click();
        },

        editPhoto: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            var file_not_supported = false;

            if(e){

                var that = this,
                    files = e.currentTarget.files;

                $.each(files, function(idx, file){

                    var re = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i,
                        fname = file.name;              

                    if(!validateFileSize(file.size)){
                        return;
                    }

                    if(!re.exec(fname)){

                        file_not_supported = true;

                    } else {
                        var reader = new FileReader();

                        reader.onload = function (e) {
                            that.$("#profileImage").removeClass("placeholder svgWrap").addClass("custom").html("").css("background-image", "url(" + e.target.result + ")");
                        }

                        reader.readAsDataURL(file);

                        that.photo_file = file;
                        
                        that.changePhoto();

                    }

                });

                if(file_not_supported == true){
                    jAlert("File extension not supported!");
                }
            }
        },

        changePhoto: function(){
            var that = this,
                image_array = new Array();

            $("#image-upload-input :input").attr("disabled", true);

            this.jquery_file_upload = new FormData();

            if(this.photo_file != null && this.photo_file != undefined){

                this.jquery_file_upload.append("files", this.photo_file, this.photo_file.name);

                image_array.push({ "Type": "Profile", "File": this.photo_file.name, "Action": "Replace" });

            }

            this.jquery_file_upload.append("imageInfo", JSON.stringify(image_array));

            $.ajax({
                url : pf.consumerURL + "/Profile",
                type: 'POST',
                data: this.jquery_file_upload,                    
                processData: false,
                contentType: false,
                success    : function(data, status, jqXHR){

                    that.profile_model = new ProfileModel();

                    that.profile_model.fetch({
                        success: function(model, resp){
                            
                            pfdialog.alert({ context: this, Body: "Profile photo updated successfully.", Title: "Success" });
                            
                            pf.session.set('PhotoURL', that.profile_model.attributes.PhotoURL);

                            that.loadData();

                        },
                        error: function(error){
                            // console.log('There was an getting your profile information',error);
                        }
                    });

                },
                error: function(req, status, error){

                    pfdialog.error({ context: this, Body: "Please contact Member Services at 844-944-9273 if you would like to update your card account information.", Title: "Error" });

                }
            });

        },

        changePassword: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            pf.navigate('#password');
        },

        close: function(){}
    });
});

